import { APIHandlerVersion, type IAPIHandlerResult } from "types/apiResponse/apiResponse";

import { APIHandler } from "utilities/apiHandler";

import {
    type ISearchBarResultResponse,
    SearchBarEntity,
    SearchBarValidateResponse,
    type SearchCategory,
} from "commonComponents/utilities/MainNavigation/searchLegacy/SearchBar.api.types";

export interface ISearchGetRequest {
    search: string;
    limit: number;
    pageSize?: number;
    categories?: SearchCategory[];
    jobIds?: number[];
}

export interface ISearchValidateRequest {
    searchItems: ISearchBarResultResponse[];
}

export interface ISearchBarHandler {
    get(request: ISearchGetRequest): IAPIHandlerResult<SearchBarEntity>;
    validateSearchItems(request: ISearchBarResultResponse[]): Promise<SearchBarValidateResponse>;
}

export class SearchBarHandler implements ISearchBarHandler {
    get(request: ISearchGetRequest): IAPIHandlerResult<SearchBarEntity> {
        const { limit, ...data } = request;
        return APIHandler(`/api/Search?limit=${limit}`, {
            method: "POST",
            data: {
                search: data.search,
                jobIds: data.jobIds ?? [],
                categories: data.categories ?? [],
            },
            responseType: SearchBarEntity,
            version: APIHandlerVersion.cancellable,
        });
    }

    async validateSearchItems(
        searchItems: ISearchBarResultResponse[],
    ): Promise<SearchBarValidateResponse> {
        return await APIHandler("/api/Search/Validate", {
            method: "POST",
            data: {
                searchItems: searchItems.map((r) => ({
                    id: r.id,
                    builderId: r.builderId,
                    jobId: r.jobId,
                    category: r.category,
                })),
            },
            responseType: SearchBarValidateResponse,
        });
    }
}
